import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LinkPopup.module.css';

export default function LinkPopup({ onClose, onSubmit }) {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [category, setCategory] = useState('hut');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSubmit({ title, url, category });
    setLoading(false);
    onClose();
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <h2>{t('mountainPage.usefulLinks.addTitle')}</h2>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label>{t('mountainPage.usefulLinks.linkTitle')}</label>
            <input 
              required
              className={styles.input}
              value={title} 
              onChange={e => setTitle(e.target.value)} 
              placeholder={t('mountainPage.usefulLinks.linkTitlePlaceholder')}
            />
          </div>
          
          <div className={styles.formGroup}>
            <label>{t('mountainPage.usefulLinks.url')}</label>
            <input 
              required
              type="url"
              className={styles.input}
              value={url} 
              onChange={e => setUrl(e.target.value)} 
              placeholder="https://..."
            />
          </div>

          <div className={styles.formGroup}>
            <label>{t('mountainPage.usefulLinks.category')}</label>
            <select 
              value={category} 
              onChange={e => setCategory(e.target.value)}
              className={styles.selectInput}
            >
              <option value="hut">{t('mountainPage.usefulLinks.categories.hut')}</option>
              <option value="weather">{t('mountainPage.usefulLinks.categories.weather')}</option>
              <option value="webcam">{t('mountainPage.usefulLinks.categories.webcam')}</option>
              <option value="cableCar">{t('mountainPage.usefulLinks.categories.cableCar')}</option>
              <option value="other">{t('mountainPage.usefulLinks.categories.other')}</option>
            </select>
          </div>

          <div className={styles.buttonGroup}>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>{t('action.cancel')}</button>
            <button type="submit" disabled={loading} className={styles.submitBtn}>
              {loading ? t('action.loading') : t('mountainPage.usefulLinks.add')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
